export default function About() {
  return (
    <section id="about" className="py-40 px-32 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-20">
          {/* Left Content */}
          <div className="flex-1">
            <p className="text-[#00D4FF] text-xs font-bold tracking-[2px] uppercase mb-6">
              About SUBJEKT
            </p>
            <h2 className="text-5xl font-bold text-[#0A0E27] leading-tight mb-8 max-w-xl">
              Protecting Digital Privacy Since Day One
            </h2>
            <p className="text-lg text-[#4B5563] leading-relaxed max-w-xl mb-12">
              At SUBJEKT d.o.o., we are dedicated to creating powerful applications that safeguard your digital life. Our VPN solution combines cutting-edge encryption technology with user-friendly design, ensuring that your online activities remain private and secure. We believe everyone deserves the right to browse freely without compromising their personal information.
            </p>
            <button className="inline-flex items-center justify-center gap-3 px-10 h-14 rounded-full bg-gradient-to-r from-[#00D4FF] to-[#0099CC] text-white font-semibold transition-all duration-300 hover:shadow-xl hover:shadow-[#00D4FF]/30 hover:-translate-y-1 whitespace-nowrap cursor-pointer">
              Learn Our Story
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
          </div>

          {/* Right Visual */}
          <div className="flex-1 flex justify-center">
            <div 
              className="relative w-full max-w-lg h-96 rounded-[32px] bg-gradient-to-br from-[#00D4FF]/10 to-[#0099CC]/10 border-2 border-transparent overflow-hidden transform -rotate-3 hover:rotate-0 transition-transform duration-500"
              style={{
                backgroundImage: 'linear-gradient(white, white), linear-gradient(135deg, #00D4FF, #9333EA)',
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box',
                boxShadow: '0 16px 48px rgba(0,212,255,0.15)'
              }}
            >
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative w-64 h-64">
                  {/* Network Nodes */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 flex items-center justify-center">
                    <i className="ri-shield-check-fill text-7xl text-[#00D4FF]"></i>
                  </div>
                  
                  {/* Orbiting Nodes */}
                  {[0, 60, 120, 180, 240, 300].map((angle, index) => {
                    const radian = (angle * Math.PI) / 180;
                    const x = Math.cos(radian) * 100;
                    const y = Math.sin(radian) * 100;
                    
                    return (
                      <div
                        key={index}
                        className="absolute top-1/2 left-1/2 w-4 h-4 bg-[#00D4FF] rounded-full animate-pulse"
                        style={{
                          transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px))`,
                          animationDelay: `${index * 0.2}s`
                        }}
                      />
                    );
                  })}
                  
                  {/* Connection Lines */}
                  <svg className="absolute inset-0 w-full h-full" style={{ transform: 'translate(-50%, -50%)', left: '50%', top: '50%' }}>
                    {[0, 60, 120, 180, 240, 300].map((angle, index) => {
                      const radian = (angle * Math.PI) / 180;
                      const x = Math.cos(radian) * 100 + 128;
                      const y = Math.sin(radian) * 100 + 128;
                      
                      return (
                        <line
                          key={index}
                          x1="128"
                          y1="128"
                          x2={x}
                          y2={y}
                          stroke="#00D4FF"
                          strokeWidth="1"
                          opacity="0.3"
                        />
                      );
                    })}
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
